import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { verifyUser, clearSuccessMessage, resendOtp } from '../../store/slices/authSlice';
import banner from '../../assets/img/pexels-earano-1683802.jpg'
import Logo from '../../components/Logo'
import Input from '../../components/fields/Input'
import ButtonLightBlue from '../../components/buttons/ButtonLightBlue'
import ErrorMessage from '../../components/messages/ErrorMessage';
import Dialog from '../../components/common/Dialog';
import GuestHeader from '../../layout/GuestHeader'
import GuestFooter from '../../layout/GuestFooter';
import {Helmet} from "react-helmet";

const Verify = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { successMessage, error, errors, token, user, isResendingOtp, isVerifying } = useSelector((state) => state.auth);
  const [showDialog, setShowDialog] = useState(false);
  const [formData, setFormData] = useState({ otp: '' });

   useEffect(() => {
    if(user === null){
      navigate('/login');
    }
  }, [user, navigate]);

  useEffect(() => {
    if (token) {
      navigate('/welcome');
    }
  }, [token, navigate]);

  useEffect(() => {
    if (successMessage) {
      dispatch(clearSuccessMessage());
    }
  }, [successMessage, dispatch]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if((formData.otp || '').length !== 6) {
      setShowDialog(true);
      return;
    }

    //i need to pass user email along with otp
    dispatch(verifyUser({ ...formData, email: user.email }));
  };

  const renderErrorMessages = () => {
    return Object.entries(errors).map(([field, messages]) => (
      <ErrorMessage key={field} message={`${messages.join(', ')}`} />
    ));
  }

  return (
    <>
      <Helmet>
          <title>Verify Email | Oreca Pro</title>
          <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <GuestHeader />
      <Dialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        title="Invalid OTP"
        cancelText="Ok"
      >
        <p className="text-custom-light-grey mb-6">The OTP must be 6 digits long.</p>
      </Dialog>
      <section
        style={{ backgroundImage: `url(${banner})` }}
        className='guest-section relative min-h-[100vh] bg-center bg-cover'
      >
        <div 
          className='absolute inset-0'
          style={{
            background: 'linear-gradient(180deg,rgba(16, 28, 34, 0) 0%, rgba(16, 28, 34, 0.15) 46%, rgba(16, 28, 34, 0.84) 55%, rgba(16, 28, 34, 1) 64%)'
          }}
        />
        <div className='w-full max-w-[340px] relative mx-auto text-center px-4 pt-[120px] md:pt-[160px]'>
          <div className='scale-[1.4] my-5'>
            <Logo />
          </div>
          <h1 className='text-3xl font-semibold my-5'>Verify</h1>
          <p className='mt-5 mb-7 font-normal'>We have emailed you a verification link. Please check your inbox and enter your 6 digit OTP below.</p>

          <form onSubmit={handleSubmit}>
            {error && <ErrorMessage message={error} />}
            {renderErrorMessages()}
              <Input
                type="text"
                id="otp"
                name="otp"
                value={formData.otp}
                onChange={handleInputChange}
                required
                placeholder="OTP (One Time Pin)"
              />
              
              <ButtonLightBlue 
                disabled={isVerifying}
                text={isVerifying ? 'Verifying...' : 'Verify'} 
              />

              <div className='mt-4 text-sm'>
                Didn't receive the OTP?{' '}
                <button 
                  type="button" 
                  className='text-custom-light-blue'
                  onClick={() => dispatch(resendOtp({ email: user.email }))}
                  disabled={isResendingOtp}
                >
                  {isResendingOtp ? 'Resending...' : 'Resend OTP'}
                </button>
              </div>
          </form>
        </div>
      </section>
      <GuestFooter />
    </>
  );
};

export default Verify;
